export default "__VITE_ASSET__BaQW3CnY__"